import { MedplumClient } from "@medplum/core";
import { Observation } from "@medplum/fhirtypes";

import { QuiltedHealthCodes } from "@/fhir/enums/quilted-health";
import { Systems } from "@/fhir/enums/systems";
import { getResourcesFromBundle, joinReferenceString, joinTokenString } from "@/utils/medplum";

/**
 * Loads birth date/time observations for an encounter (non-cancelled, most recently updated first).
 */
export async function fetchEncounterBirthObservations(
  medplum: MedplumClient,
  clientId: string,
  encounterId: string,
): Promise<Observation[]> {
  const birthObservations = await medplum.search("Observation", {
    subject: joinReferenceString("Patient", clientId),
    encounter: joinReferenceString("Encounter", encounterId),
    code: joinTokenString(Systems.QH, QuiltedHealthCodes.BirthDateTime),
    "status:not": "cancelled",
    _sort: "-_lastUpdated",
  });

  return getResourcesFromBundle("Observation", birthObservations) as Observation[];
}
